import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "features/Application/slices/createFetchingItemsSlice";
import { ContentTypesEnum, ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type PayloadAction } from "@reduxjs/toolkit";
import { type PeopleContent } from "../../types";

export interface ContentAssignmentState extends FetchingItemsState<PeopleContent> {
  selected: { [key in ContentTypesEnum]?: number[] };
  selectedType: ContentTypesEnum;
}

const initialState: ContentAssignmentState = {
  isLoading: false,
  items: [],
  itemsCount: 0,
  selected: {},
  selectedType: ContentTypesEnum.Flows,
};

const slice = createFetchingItemsSlice({
  initialState,
  namePayload: {
    entity: ReducerEntityPrefixTypes.Content,
    name: "ContentAssignment",
    namespace: ReducerNamespaceTypes.People,
  },
  reducers: {
    setSelected: (state, action: PayloadAction<{ context: ContentTypesEnum; selected: number[] }>) => {
      const { context, selected } = action.payload;
      state.selected[context] = selected;
    },
    setSelectedType: (state, action: PayloadAction<ContentTypesEnum>) => {
      state.selectedType = action.payload;
    },
    resetItems: (state) => {
      return { ...state, ...initialState, selected: state.selected, selectedType: state.selectedType };
    },
  },
});

export const { fetchBegin, fetchFailure, fetchSuccess, reset, resetItems, setSelected, setSelectedType } =
  slice.actions;

export default slice.reducer;
